import React from 'react';

import { useTranslation } from 'react-i18next';


const UserSettings = (props) => {
    const { t } = useTranslation();

    return (
        <div>
            <h1>{t("User settings")} </h1>
            <p>Set user settings....(?) </p>
            <ul>
                <li><a href=''>set -1 </a> set -1 </li>
                <li><a href=''>set -2</a> set -2</li>
                <li><a href=''>set -3</a> set -3</li>
                <li><a href=''>set -4</a> set -4</li>
                <li><a href=''>set -5</a> set -5</li>
            </ul>
            <p>Settings details</p>
            <ul>
                <li><strong>Setting list</strong>Setting list - value </li>
            </ul>

        </div>
    );
};

export default UserSettings ;


